// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__kXlYa","flex":"Footer_flex__LQC-J","icons":"Footer_icons__QDrf7"};